import React from "react";
import { SocialMediaButton } from "../AccountLinkingPage";
import InstagramIcon from "src/img/noticeboard/instagram.svg";
import OauthPopup from "./OauthPopup";
import { SocialMediaPlatformColors } from "../utils/Enums";
import { getInstagramOauthUrl } from "../utils/oauth";

const InstagramLogin = ({ onSuccess }) => {

    return (
        <OauthPopup
            url={getInstagramOauthUrl()}
            onCode={oauthCode => onSuccess(oauthCode)}
            onClose={() => "" } 
        >
            <SocialMediaButton backgroundColor={SocialMediaPlatformColors.INSTAGRAM}>
                <img src={InstagramIcon} alt="Instagram Icon" style={{ marginRight: "12px" }}/>
                Connect Instagram
            </SocialMediaButton>
        </OauthPopup>
    );
};

export default InstagramLogin;
